<div class="modal-header">
  <h4 class="modal-title">
    Изпращане на предложение
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loadingSubmit"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  @if (!loadingData) {
    <p class="mb-2"><strong class="text-muted">Артикул:</strong> {{ adTitle }}</p>
    <p class="mb-2"><strong class="text-muted">Обявена цена:</strong> {{ adPrice.toFixed(2) }} лв.</p>
    <p><strong class="text-muted">Позволен диапазон:</strong>
      от {{ priceRange.minimumPrice.toFixed(2) }} лв. до
      {{ priceRange.maximumPrice.toFixed(2) }} лв.
    </p>
    <hr>
    <form [formGroup]="form">
      <fieldset class="mb-3">
        <label for="offeredPrice" class="mb-0 form-label">Предложена сума*</label>
        <input
          id="offeredPrice"
          type="number"
          formControlName="offeredPrice"
          class="form-control"
          placeholder="Въведете Вашето предложение..."
          aria-label="Предложена сума"
          [class.is-valid]="offeredPrice?.touched && offeredPrice?.valid"
          [class.is-invalid]="offeredPrice?.touched && offeredPrice?.invalid">
        <p class="invalid-feedback m-0">
          Моля, въведете сума между
          {{ priceRange.minimumPrice.toFixed(2) }} и
          {{ priceRange.maximumPrice.toFixed(2) }} лв.
        </p>
      </fieldset>
      <fieldset>
        <label for="offerMessage" class="mb-0 form-label">Съобщение до продавача</label>
        <textarea
          id="offerMessage"
          rows="4"
          formControlName="offerMessage"
          class="form-control"
          placeholder="Добавете кратко съобщение или уточнение (по желание)..."
          aria-label="Съобщение до продавача"></textarea>
      </fieldset>
    </form>
  } @else {
    <div class="text-center">
      <h3><i class="text-muted fa-solid fa-spinner fa-spin"></i></h3>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    [disabled]="loadingSubmit"
    class="btn btn-outline-secondary"
    (click)="closeModal()">
    Затвори
  </button>
  <button
    type="button"
    [disabled]="loadingSubmit"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loadingSubmit) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    Изпрати
  </button>
</div>
